module.exports = __webpack_public_path__ + "img/icon-info copy.622e549e.svg";